import PropTypes from 'prop-types'
import { useState, useEffect, useCallback } from 'react'
import * as tiendasOficialesService from '../servicios/tiendasOficialesService'
import CategoriasTiendasOficiales from './CategoriasTiendasOficiales'

const ContenedorTiendas = (props) => {
  const [categorias, setCategorias] = useState([])

  const buscarTiendas = useCallback(async () => {
    const { data: categorias } = await tiendasOficialesService.buscarTodas(props.buscar)
    setCategorias(categorias)
  }, [props.buscar])

  useEffect(() => {
    buscarTiendas()
  }, [buscarTiendas])

  const arrCategoriasId = [...new Set(categorias.map((cat) => cat.idCategoria))]

  return (
    <div className="row">
      <div className="col">
        {arrCategoriasId.map((catId) => (
          <CategoriasTiendasOficiales
            key={catId}
            catId={catId}
            categoria={categorias.filter((c) => c.idCategoria === catId)}
          />
        ))}
      </div>
    </div>
  )
}

ContenedorTiendas.propTypes = {
  buscar: PropTypes.string
}

export default ContenedorTiendas
